"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.library.empty': 'Brak postów',
    'socialMediaPlan.library.emptyDesc': 'Stwórz pierwszy post za pomocą kreatora.',
    'socialMediaPlan.library.contains_errors': 'Ten post zawiera błędy publikacji',
};
